import { Routes } from '@angular/router';
import { DwLanguageService } from '@webdpt/framework';
import { ForgetComponent } from './forget.component';
var ɵ0 = {
    dwRouteData: {
        programId: 'dw-forget',
        dwAuthId: 'forget'
    }
};
var routes = [
    {
        path: '',
        component: ForgetComponent,
        pathMatch: 'prefix',
        data: ɵ0,
        resolve: {
            transaction: DwLanguageService
        }
    }
];
var ForgetRoutingModule = /** @class */ (function () {
    function ForgetRoutingModule() {
    }
    return ForgetRoutingModule;
}());
export { ForgetRoutingModule };
export { ɵ0 };
